import sharedRoutePaths from "@/shared/router/routePaths";

export default {
  ...sharedRoutePaths,
  ssoLogin: "/login",
};
